<!-- 表具实时数据 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
          <!-- 按钮操作区域 -->
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex;margin-top: 10px;">
              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                  </span>
                  -->
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree">
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户编号')">
                  <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户姓名')">
                  <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('用户地址')">
                    <j-input :placeholder="$t('用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('册号')">
                    <a-input :placeholder="$t('请输入册号')" v-model="queryParam.mtVolumeNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('上报方式')">
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      :placeholder="$t('请选择上报方式')"
                      v-model="meterUpWay"
                      @change="handleChangeMeterUpWay"
                    >
                      <a-select-option v-for="(item,key) in SendWayObj" :value="key" :key="key">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('阀门是否故障')">
                    <a-select
                      v-model="queryParam.meterValveFault"
                      :placeholder="$t('请选择阀门是否故障')"
                      >
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('故障') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('阀门状态')">
                    <a-select
                      mode="multiple"
                      style="width: 100%"
                      :placeholder="$t('请选择阀门状态')"
                      v-model="meterValveStatus"
                      @change="handleChangeMeterValveStatus"
                    >
                      <a-select-option v-for="(item,key) in Mn100FkStatusObj" :value="key" :key="key">
                        {{item}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('电池状态')">
                    <a-select
                      v-model="queryParam.meterBatteryStatus"
                      :placeholder="$t('请输入电池状态')"
                      >
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('欠压') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('有无磁干扰')">
                    <a-select :placeholder="$t('请输入有无磁干扰')" v-model="queryParam.meterMagentic">
                      <a-select-option :value="0">
                        {{ $t('正常') }}
                      </a-select-option>
                      <a-select-option :value="1">
                        {{ $t('有') }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表类型')">
                    <!--
                    <a-select placeholder="请输入表类型" v-model="queryParam.meterType  ">
                      <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                        {{data.mtCode}}
                      </a-select-option>
                    </a-select>
                    -->
                    <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请表类型')" dictCode="meter_type" />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('表口径')">
                    <a-select
                      mode="multiple"
                      v-model="meterCaliber"
                      :placeholder="$t('请选择表口径')"
                      @change="handleChangeMeterCaliber"
                      >
                      <a-select-option v-for="data in userCaliberList" :key="data.id" :value="data.mtCaliber">
                        DN{{data.mtCaliber}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="8">
                  <a-form-model-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls($t('表具实时数据'))">{{ $t('导出') }}</a-button>
          <a-button type="primary" icon="file-pdf" :loading="pdfLoading" @click="handleExportPdf">{{ $t('抄表卡(最多500户)') }}</a-button>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
        <!-- table区域-begin -->
        <div class="table-fixed">
          <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a> -->
          <span style="float:right;">
            <!-- <a @click="loadData()"><a-icon type="sync" />刷新</a> -->
            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
              <template slot="content">
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </template>
            </a-popover>
          </span>
          <!-- </div> -->
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :components="drag(columns)"
            @change="handleTableChange">
            <div slot="filterDropdown">
              <a-card>
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="12" :key="item.key">
                          <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </a-card>
            </div>
            <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
            <span slot="action" slot-scope="text, record" class="action">
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              <a :disabled="record.meterType=='20-2'||record.meterType=='Y14-4G'"
                  :style="{color: record.meterType=='20-2'?'rgba(0, 0, 0, 0.25)':''}"
              v-has="'querycommandqueue'" @click="record.meterType=='80'||record.meterType=='15'?showMeterCommandQueue(record):showMeterCommandOldQueue(record)">{{ $t('命令队列') }}</a>
              <span v-has="'debuggingcommands'">
                <a :disabled="record.meterType=='20-2'||record.meterType=='Y14-4G'"
                  :style="{color: record.meterType=='20-2'?'rgba(0, 0, 0, 0.25)':''}"
                @click="handleCommand(record)">{{ $t('命令下发') }}</a>
              </span>
              <a-dropdown>
                <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleIntervalDetail(record)" :disabled="record.meterType!='80'&&record.meterType!='15'" :style="{color: record.meterType!='80'&&record.meterType!='15'?'rgba(0, 0, 0, 0.25)':''}">{{ $t('间隔流量') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handleSenseDetail(record)" :disabled="record.meterType!='80'&&record.meterType!='15'" :style="{color: record.meterType!='80'&&record.meterType!='15'?'rgba(0, 0, 0, 0.25)':''}">{{ $t('密集流量') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link :to="{name: 'MeterUpDataRecordList',params:{meterId: record.meterId}}">
                      {{ $t('历史数据') }}
                    </router-link>
                    <!--<a @click="{name: 'meterUserAccountList',params:{accountAlarmType: 1}}">历史数据</a>-->
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handleReadMeterData(record)" :disabled="record.meterType!='Y17-N'&&record.meterType!='Y18-17'&&record.meterType!='Y10-QN'" :style="{color: record.meterType!='Y17-N'&&record.meterType!='Y18-17'&&record.meterType!='Y10-QN'?'rgba(0, 0, 0, 0.25)':''}">{{ $t('获取抄表数据') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handlePrintTag(record)">{{ $t('打印抄表卡') }}</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <meter-elef-up-data-modal ref="elefUpDataModal" @ok="modalFormOk"></meter-elef-up-data-modal>
        <meter-us-up-data-modal ref="usModalForm" @ok="modalFormOk"></meter-us-up-data-modal>
        <meter-up-data-modal ref="modalForm" @ok="modalFormOk"></meter-up-data-modal>
        <debug-newCommand-modal ref="debugNewCommandModal" @ok="modalFormOk"></debug-newCommand-modal>
        <meter-debuggingCommands-modal ref="debuggingCommandsModal" @ok="modalFormOk"></meter-debuggingCommands-modal>
        <meter-command-queue-modal ref="metrCommandQueueModal" @ok="modalFormOk"></meter-command-queue-modal>
        <meter-command-queue-old-modal ref="metrCommandQueueOldModal" @ok="modalFormOk"></meter-command-queue-old-modal>
        <meter-intervalAndSense-record-modal ref="meterIntervalAndSenseRecordModal" @ok="modalFormOk"></meter-intervalAndSense-record-modal>
        <meter-dykj-debuggingCommands-modal ref="dykjDebuggingCommandsModal" @ok="modalFormOk"></meter-dykj-debuggingCommands-modal>
        <debug-uSCommand-modal ref="debugUSCommandModal" @ok="modalFormOk"></debug-uSCommand-modal>
        <MeterY10QNDebuggingCommandsModal ref="y10qnDebuggingCommandsModal" @ok="modalFormOk"></MeterY10QNDebuggingCommandsModal>
        <MeterY17NDebuggingCommandsModal ref="y17nDebuggingCommandsModal" @ok="modalFormOk"></MeterY17NDebuggingCommandsModal>
        <MeterY18NDebuggingCommandsModal ref="y18nDebuggingCommandsModal" @ok="modalFormOk"></MeterY18NDebuggingCommandsModal>
        <MeterCommonCommandsModal ref="meterCommonCommandsModal" @ok="modalFormOk"></MeterCommonCommandsModal>
        <meter-tag-print-modal ref="meterTagPrintModal"></meter-tag-print-modal>
      </a-card>
    </a-col>
  </a-row>  
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUpDataModal from './modules/MeterUpDataModal'
  import { getAction,downFile,postAction,downloadFile } from '@/api/manage'
  import {isUndefined} from'@/utils/validate'
  import { listSize,filterObj } from '@/utils/util'
  import configService from '@/utils/service/config.service'
  import debugNewCommandModal from './modules/debugNewCommandModal'
  import MeterDebuggingCommandsModal from './modules/MeterDebuggingCommandsModal'
  import MeterDykjDebuggingCommandsModal from './modules/MeterDykjDebuggingCommandsModal'
  import meterCommandQueueOldModal from './modules/meterCommandQueueOldModal'
  import meterCommandQueueModal from './modules/meterCommandQueueModal'
  import Vue from 'vue'
  import {netTypeObj,Mn100FkStatusObj,SendWayObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import MeterIntervalAndSenseRecordModal from './modules/MeterIntervalAndSenseRecordModal'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'
  import MeterUsUpDataModal from './modules/MeterUsUpDataModal'
  import debugUSCommandModal from './modules/debugUSCommandModal'
  import MeterElefUpDataModal from './modules/MeterElefUpDataModal'
  import MeterY10QNDebuggingCommandsModal from './modules/MeterY10QNDebuggingCommandsModal'
  import MeterY17NDebuggingCommandsModal from './modules/MeterY17NDebuggingCommandsModal'
  import MeterY18NDebuggingCommandsModal from './modules/MeterY18NDebuggingCommandsModal'
  import MeterCommonCommandsModal from './modules/MeterCommonCommandsModal'
  import MeterTagPrintModal from './modules/MeterTagPrintModal'


  export default {
    name: 'MeterUpDataList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterUpDataModal,
      MeterUsUpDataModal,
      debugNewCommandModal,
      MeterDebuggingCommandsModal,
      meterCommandQueueOldModal,
      meterCommandQueueModal,
      MeterIntervalAndSenseRecordModal,
      MeterDykjDebuggingCommandsModal,
      JInput,
      debugUSCommandModal,
      MeterElefUpDataModal,
      MeterY10QNDebuggingCommandsModal,
      MeterY17NDebuggingCommandsModal,
      MeterY18NDebuggingCommandsModal,
      MeterCommonCommandsModal,
      MeterTagPrintModal
    },
    data () {
      return {
        description: 'meter_up_data管理页面',
        collapsed: false,
        netTypeObj,
        Mn100FkStatusObj,
        SendWayObj,
        meterTypeObj,
       //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterUpData/list",
          delete: "/jeecg-charge/meter/meterUpData/delete",
          deleteBatch: "/jeecg-charge/meter/meterUpData/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpData/exportXls",
          exportPdfUrl: "/jeecg-charge/meter/meterUpData/exportPdf",
          importExcelUrl: "jeecg-charge/meter/meterUpData/importExcel",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址  
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
          activeGetMeterUpdate:"/jeecg-charge/meter/meterUpData/activeGetMeterUpdate"
        },
        dictOptions:{},
        userTypeList:[],  //表类型
        userCaliberList:[],  // 表口径
        meterUpWay: [],
        meterValveStatus: [],
        meterCaliber: [],
        pdfLoading: false
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
      this.queryUserCaliberList();
      this.queryUserTypeList();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex:'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width:200,
            ellipsis: true,
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('册号'),
            align:"center",
            dataIndex: 'mtVolumeNo',
            width: 150
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            // customRender:function (t,r,index) {
            //   let data = meterTypeObj
            //   if(isUndefined(data[t])) {
            //     return t
            //   }
            //   return data[t]
            // },
            width:100,
            ellipsis: true
          },{
            title: this.$t('表端时间'),
            align:"center",
            dataIndex: 'meterTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('阀门是否故障'),
            align:"center",
            dataIndex: 'meterValveFault',
            customRender: (t, r, index) => {
              let data = {"0": this.$t("正常"),"1": this.$t("故障"),"null": this.$t("正常")}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex:'meterValveStatus',
            customRender: (t, r, index) => {
              let data = Mn100FkStatusObj;
              if(isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('阀控状态'),
            align:"center",
            dataIndex: 'meterHasValveControll',
            customRender: (t, r, index) => {
              let data = {"0": this.$t("无阀控"),"1": this.$t("有阀控")}
              if(isUndefined(data[t])) {
                return "--"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('上报累计流量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage',
            width:100,
            ellipsis: true
          },
          /*
          {
            title:'电池状态',
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"欠压"}
              if(isUndefined(data[t])) {
                return "其他"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },
          {
            title:'存储状态',
            align:"center",
            dataIndex: 'meterSaveFault',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"故障"}
              if(isUndefined(data[t])) {
                return "其他"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },*/{
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'meterUpWay',
            customRender: (t, r, index) => {
              let data = SendWayObj;
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          /*
          {
            title:'电池状态',
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender:function (t,r,index) {
              let data = {"0": "正常","1":"欠压"}
              if(isUndefined(data[t])) {
                return "其他"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'阀门状态',
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender:function (t,r,index) {
              let data = Mn100FkStatusObj
              if(isUndefined(data[t])) {
                return "其他"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'磁干扰',
            align:"center",
            dataIndex: 'meterMagetic',
            customRender:function (t,r,index) {
              let data = {"1": "有","0":"正常"}
              if(isUndefined(data[t])) {
                return "其他"
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title:'表端上报数据次数',
            align:"center",
            dataIndex: 'meterUpTimes',
            width:100,
            ellipsis: true
          },{
            title:'上报平台没有回应数',
            align:"center",
            dataIndex: 'meterUpNoResponse',
            width:100,
            ellipsis: true
          },*/
          {
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender: (t, r, index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:250,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handlePrintTag(record) {
        this.$refs.meterTagPrintModal.edit(record)
      },
      // 批量导出抄表卡PDF:复用列表当前筛选条件(含区域 areaId),后端生成多页 PDF 下载
      handleExportPdf() {
        // 与 handleExportXls 同源拼参数:queryParam 含 areaId(区域树 nodeClick 写入)
        let param = Object.assign({}, this.queryParam, this.isorter, this.filters)
        param = Object.assign(param, this.uniqueParam)
        this.pdfLoading = true
        // 直接用 downFile 拿 blob,自行判断是否为合法 PDF;
        // 后端在数据量超限等异常时会返回 JSON 错误(blob 里有 JSON 文本),需解析后提示用户,否则会下载成损坏 pdf。
        downFile(this.url.exportPdfUrl, param).then((data) => {
          if (!data || data.size === 0) {
            this.$message.warning(this.$t('文件下载失败'))
            return
          }
          // PDF 文件头必然是 "%PDF";非 PDF 说明后端返回了错误 JSON,读取出来提示
          return data.slice(0, 4).text().then((head) => {
            if (head === '%PDF') {
              this.downloadBlob(data, this.$t('抄表卡.pdf'))
            } else {
              // 解析后端错误信息
              data.text().then((txt) => {
                let msg = this.$t('导出失败')
                try {
                  let res = JSON.parse(txt)
                  msg = res.message || msg
                } catch (e) {
                  msg = txt || msg
                }
                this.$message.error(msg)
              })
            }
          })
        }).catch(() => {
          this.$message.error(this.$t('导出抄表卡PDF失败'))
        }).finally(() => {
          this.pdfLoading = false
        })
      },
      // blob 触发浏览器下载
      downloadBlob(blob, fileName) {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, fileName)
          return
        }
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },
      handleReadMeterData(row){
        let params = {
          meterId: row.meterId,
          meterType: row.meterType,
        }
        postAction(this.url.activeGetMeterUpdate,params).then(res=>{
          if(res.success){
            this.$message.success(res.result);
            this.loadData();
          }
        })
      },
      handleCommand(record) {
        if(record.meterType=='80'||record.meterType=='15') {
          this.debugNewCommand(record);
        }else if(record.meterType=='MN100-2D') {
          this.dykjDebuggingCommands(record);
        }else if(record.meterType=='Y10-QN') {
          this.y10qn0DebuggingCommands(record);
        }else if(record.meterType=='Y17-N') {
          this.y17n0DebuggingCommands(record);
        }else if(record.meterType == 'Y18-N'){
          this.y18nDebuggingCommands(record);
        }else if(record.meterType=='Y18-17') {
          this.y17n0DebuggingCommands(record);
        }else if(record.meterType=='MN100') {
          this.debuggingCommands(record);
        }else{
          // 通用对接的命令
          this.debuggingCommonCommands(record);
        }
      },
      debuggingCommonCommands(record) {
        this.$refs.meterCommonCommandsModal.edit(record)
        this.$refs.meterCommonCommandsModal.title = this.$t('命令下发')
      },
      // 新协议远程命令下发
      debugNewCommand(record) {
        console.log(record)
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            let result = res.result.records[0];
            if(record.meterType == '15') {
              that.$refs.debugUSCommandModal.edit(result);
              that.$refs.debugUSCommandModal.title = this.$t('命令下发');
            }else{
              that.$refs.debugNewCommandModal.edit(result);
              that.$refs.debugNewCommandModal.title = this.$t('命令下发');
            }
            
          }
        })
      },
      debuggingCommands(record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            that.$refs.debuggingCommandsModal.edit(res.result.records[0]);
            that.$refs.debuggingCommandsModal.title = this.$t('命令下发');
          }
        })
      },
      dykjDebuggingCommands(record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            that.$refs.dykjDebuggingCommandsModal.edit(res.result.records[0]);
            that.$refs.dykjDebuggingCommandsModal.title = this.$t('命令下发');
          }
        })
      },
      // 宁波水表
      y15n0DebuggingCommands(record) {
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            that.$refs.y15n0DebuggingCommandsModal.edit(res.result.records[0]);
            that.$refs.y15n0DebuggingCommandsModal.title = this.$t('命令下发');
          }
        })
      },
      y10qn0DebuggingCommands(record){
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            that.$refs.y10qnDebuggingCommandsModal.edit(res.result.records[0]);
            that.$refs.y10qnDebuggingCommandsModal.title = this.$t('命令下发');
          }
        })
      },
      y17n0DebuggingCommands(record){
        let params = {}
        params.pageNo = 1;
        params.pageSize = 1;
        params.meterId = record.meterId;
        let that = this;
        getAction('/jeecg-charge/meter/meterinfo/list', params).then((res) => {
          if(res.success){
            that.$refs.y17nDebuggingCommandsModal.edit(res.result.records[0]);
            that.$refs.y17nDebuggingCommandsModal.title = this.$t('命令下发');
          }
        })
      },
      y18nDebuggingCommands(record){
        this.$refs.y18nDebuggingCommandsModal.edit(record);
        this.$refs.y18nDebuggingCommandsModal.title = this.$t('命令下发');
      },
      showMeterCommandQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record);
      },
      showMeterCommandOldQueue(record) {
        this.$refs.metrCommandQueueOldModal.edit(record);
      },
      handleChangeMeterUpWay(value) {
        this.queryParam.meterUpWay= value +"";
      },
      handleChangeMeterValveStatus(value) {
        this.queryParam.meterValveStatus= value +"";
      },
      handleChangeMeterCaliber(value) {
        this.queryParam.meterCaliber= value +"";
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
            console.log(this.userTypeList);
          }
        }) 
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      handleIntervalDetail(record) {
        // 间隔流量
        record.dataType = 1;
        this.$refs.meterIntervalAndSenseRecordModal.edit(record);
      },
      handleSenseDetail(record) {
        // 密集流量
        record.dataType = 2;
        this.$refs.meterIntervalAndSenseRecordModal.edit(record);
      },
      handleMeterUpDataRecord(record) {

      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.meterUpWay = []
        this.meterCaliber = []
        this.meterValveStatus = []
        this.loadData(1);
      },
      handleDetail:function(record){
        console.log(record)
        if(record.meterType == '15') {
          this.$refs.usModalForm.edit(record);
          this.$refs.usModalForm.title=this.$t("详情");
          this.$refs.usModalForm.disableSubmit = true;
        }else if(record.meterType == 'Y14-4G'){
          // 迅尔电磁流量计
          this.$refs.elefUpDataModal.edit(record);
          this.$refs.elefUpDataModal.title=this.$t("详情");
          this.$refs.elefUpDataModal.disableSubmit = true;
        }else{
          this.$refs.modalForm.edit(record);
          this.$refs.modalForm.title=this.$t("详情");
          this.$refs.modalForm.disableSubmit = true;
        }
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>